import _mapKeys from 'lodash/mapKeys';
import _mapValues from 'lodash/mapValues';

export function deepTransformKeys(obj, transformFn) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepTransformKeys(item, transformFn));
  }

  return _mapValues(
    _mapKeys(obj, (value, key) => transformFn(key)),
    (value) => deepTransformKeys(value, transformFn),
  );
}

export function setNestedValue(obj, path, value) {
  const parts = path.split('.');
  let current = obj;
  parts.forEach((part, index) => {
    if (index === parts.length - 1) {
      current[part] = value;
    } else {
      current[part] ||= {};
      current = current[part];
    }
  });
}

export function getNestedValue(obj, path) {
  const parts = path.split('.');
  let current = obj;
  for (const part of parts) {
    if (current[part] === undefined) {
      return;
    }
    current = current[part];
  }
  return current;
}
